import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b477386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-ranking-page" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold mb-1" }, "Ranking de Times"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, " Pontuação somada das máquinas de campeonato concluídas pelos membros. ")
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Meu Time ")
const _hoisted_5 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-info",
  role: "status"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "card"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center text-muted py-10" }, " Nenhum time no ranking ainda. Times precisam de ao menos 2 membros. ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "card"
}
const _hoisted_12 = { class: "card-body p-0" }
const _hoisted_13 = { class: "table table-row-bordered align-middle mb-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "ps-6",
      style: {"width":"70px"}
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Time"),
    /*#__PURE__*/_createElementVNode("th", null, "País"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Membros"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end pe-6" }, "Pontos")
  ])
], -1))
const _hoisted_15 = { class: "ps-6 fw-bold" }
const _hoisted_16 = { class: "symbol symbol-40px me-3" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-muted me-1" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-end pe-6 fw-bold text-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: "/groups/me",
        class: "btn btn-sm btn-info"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_ctx.ranking.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranking, (group, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: group.id
                    }, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(index + 1) + "º", 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: `/groups/${group.id}`,
                          class: "d-flex align-items-center text-dark fw-bold text-hover-info"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("img", {
                                src: group.icon_path || '/media/avatars/blank.png',
                                alt: ""
                              }, null, 8, _hoisted_17)
                            ]),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(group.tag), 1),
                            _createTextVNode(" " + _toDisplayString(group.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.flagUrl(group.country))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.flagUrl(group.country),
                              class: "country-flag me-2",
                              alt: ""
                            }, null, 8, _hoisted_19))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.countryName(group.country)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(group.members_count), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(group.points), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
  ]))
}